import React from 'react'
import { Container, Image } from 'react-bootstrap'
import "../styles/notfound.scss"
import { useNavigate } from 'react-router'
const NotFound = () => {
    const navigate = useNavigate();
    return (
        <>
            <Container fluid className='w-100 not-found-container'>
                <div className='not-found-wrapper'>
                    <Image src="/images/not_found.svg" alt="page not found" />
                    <h2 >Page not found!</h2>
                    <p className='not-found-msg'>Looks like this page doesn’t exist anymore. But don’t worry — we’ll help you find your way back</p>
                    <button className='not-found-back cursor-pointer' onClick={() => navigate(-1)}>Go Back</button>
                </div>
            </Container>
        </>
    )
}

export default NotFound